import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Mail, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Logo } from "../components/Logo";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/tableau-de-bord";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Bienvenue !");
      navigate(u.role === "admin" ? "/admin" : u.role === "expert" ? "/expert" : "/tableau-de-bord");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-4 py-16">
      <Logo />
      <div className="glass mt-8 w-full rounded-3xl border border-celeste-or/15 p-7">
        <h1 className="font-serif text-2xl text-celeste-ivoire">Connexion</h1>
        <p className="mt-1 text-sm text-celeste-lilas/70">Retrouvez vos guidances et votre portefeuille.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-celeste-lilas/60" />
            <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Adresse e-mail" className="bg-celeste-night/50 border-celeste-violet/30 pl-9 text-celeste-ivoire" />
          </div>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-celeste-lilas/60" />
            <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Mot de passe" className="bg-celeste-night/50 border-celeste-violet/30 pl-9 text-celeste-ivoire" />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full gold-btn font-semibold">
            {busy ? "Connexion…" : "Se connecter"}
          </Button>
        </form>

        <div className="my-5 flex items-center gap-3 text-xs text-celeste-lilas/50">
          <div className="h-px flex-1 bg-celeste-or/15" /> ou <div className="h-px flex-1 bg-celeste-or/15" />
        </div>
        <Button data-testid="google-login-btn" onClick={googleLogin} variant="ghost"
          className="w-full border border-celeste-violet/30 text-celeste-ivoire hover:bg-celeste-violet/15">
          Continuer avec Google
        </Button>

        <p className="mt-6 text-center text-sm text-celeste-lilas/70">
          Pas encore de compte ? <Link to="/inscription" className="text-celeste-or hover:underline">Créer un compte</Link>
        </p>
      </div>
    </div>
  );
}
